import type { ComponentInit } from "@scripts/registry";
import { createTrack } from "@scripts/track";

const TRACK = "[data-fa-squad-listing-track]";
const ITEM = "[data-fa-squad-listing-item]";
const PREV = '[data-fa-squad-listing-arrow="prev"]';
const NEXT = '[data-fa-squad-listing-arrow="next"]';

export const initSquadListing: ComponentInit = (root) => {
	const track = root.querySelector<HTMLElement>(TRACK);
	const prev = root.querySelector<HTMLElement>(PREV);
	const next = root.querySelector<HTMLElement>(NEXT);

	if (!track || !prev || !next) return;

	return createTrack({ track, prev, next, item: ITEM });
};
